<div
  (appClickOutside)="closePopup()"
  class="filter-dropdown">
  <button
    class="filter-trigger-btn"
    (click)="show = !show">
    @if (activeFilter()) {
      <span class="filter-badge">
        <span class="visually-hidden">Filter applied</span>
      </span>
    }
    <i class="pays-icon ic-filter"></i>
  </button>
  <div
    [ngClass]="{ 'filter-wide': filterWide, 'filter-open': show, 'filter-close': !show }"
    class="filter-container">
    <div class="row mb-4">
      <div class="col fw-semibold">Filter by</div>
      <div class="col-auto ms-auto">
        <button
          (click)="onReset()"
          class="btn-reset link-secondary fw-semibold">
          Clear All
        </button>
      </div>
    </div>
    @if (filterGroups.length > 0) {
      @for (group of filterGroups; track group.filterLabel; let groupIndex = $index) {
        <div>
          <!-- Only show filter group if it's not hidden -->
          @if (!group.hidden) {
            <div class="row align-items-center">
              <div class="col">
                <p class="small">{{ group.filterLabel }}</p>
              </div>
              @if (group.type === FilterGroupType.radio) {
                <div class="col-auto">
                  <button
                    (click)="onResetGroup(group)"
                    class="btn-reset small link-secondary mb-3">
                    Reset
                  </button>
                </div>
              }
            </div>
            <div class="row row-cols-2 gy-2">
              @for (option of group.options; track option.label; let optionIndex = $index) {
                <div class="col">
                  <input
                    class="form-check-input me-3"
                    [type]="option.type"
                    [name]="'group_' + groupIndex"
                    [id]="'group_' + groupIndex + '_option_' + optionIndex"
                    [checked]="option.checked"
                    (change)="selectOption(groupIndex, optionIndex, option.type)" />
                  <label
                    class="form-check-label"
                    [for]="'group_' + groupIndex + '_option_' + optionIndex">
                    @if (option.label === TransactionStatusLabel.SYNCHED) {
                      Synced
                    } @else {
                      {{ option.label }}
                    }
                  </label>
                </div>
              }
            </div>
            <hr class="mb-3" />
          }
        </div>
      }
    }
    <ng-content></ng-content>
    <button
      id="applyFilter"
      class="btn btn-primary w-100 mb-2"
      (click)="onApplyFilter()">
      Apply
    </button>
    <button
      class="btn btn-outline-dark w-100"
      (click)="closePopup()">
      Cancel
    </button>
  </div>
</div>
